<template>
  <section class="consultation">
    <h3>{{ $t('message.consultation') }}</h3>
    <div class="cards">
      <div class="card" v-for="(item, index) of windows" :key="index">
        <div class="name">{{ item[$i18n.locale].name }}</div>
        <a class="item" v-for="(concact, index) of item.concacts" :key="index" :href="`${concact.protocol}${concact.value}`" target="_blank">
          <span><Icon :type="concact.type" /> {{concact.value}}</span> <div class="action">{{ $t('noun.concact') }}</div>
        </a>
        <div class="description" v-html="item[$i18n.locale].description" />
      </div>
    </div>
  </section>
</template>

<script>
import { windows } from 'ncovjp-data/consultation.json'
import Icon from '@/components/Icon'

export default {
  name: 'Consultation',
  data () {
    return {
      windows,
    }
  },
  components: {
    Icon,
  },
}
</script>

<style lang="less" scoped>
.consultation {
  padding: 0 24px;
  // border-bottom: 1px solid #f9f9f9;
  h3 {
    color: #333;
    font-size: 24px;
    font-weight: bold;
    line-height: 1em;
    margin: 1.5em 0;
    padding: 0;
  }
  .cards {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .card {
    width: 100%;
    max-width: 240px;
    border: 1px solid #ebebeb;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.05);
    background-color: #fff;
    padding: 18px 24px;
    margin-bottom: 24px;
    font-size: 14px;
    text-align: left;
    color: #555;
    a {
      color: #555;
      text-decoration: none;
    }
    .name {
      color: #333;
      font-size: 16px;
      line-height: 1em;
      padding: 0;
      margin: 0 0 1em;
    }
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.5em 0;
      .action {
        font-size: 12px;
        color: #555;
        padding: 2px 12px;
        border: 1px solid #555;
        border-radius: 4px;
      }
    }
    .description {
      border-top: 1px dashed hsl(0, 0%, 95%);
      margin-top: 1em;
      padding-top: 1em;
    }
  }
}
</style>
